import { Notification, NotificationType } from '../models';

export const mockNotifications: Notification[] = [
  {
    id: '3f1b8c2e-8a3f-4c7b-9a2a-1f6e9d7c1a01',
    recipientId: 'b2e7c1a4-4d91-4f3a-a7c3-91f1d2a8c101',
    notificationType: NotificationType.Corporate,
    notificationTypeDisplay: 'Corporate',
    title: 'Company Policy Update',
    body: 'Please review the updated workplace conduct policy effective immediately across all Utah locations.',
    isRead: false,
    actionRequired: true,
    createdAt: '2025-01-10T09:15:00Z',
    senderName: 'HR Department',
    actions: [
      {
        id: 1,
        actionType: 'link',
        actionLabel: 'View Policy',
        actionUrl: 'https://company.example.com/policies/conduct',
        isPrimary: true,
      },
    ],
  },
  {
    id: '7a9c0f4b-2d64-4a1e-9c8e-6b1a2f9d2b02',
    recipientId: 'b2e7c1a4-4d91-4f3a-a7c3-91f1d2a8c101',
    notificationType: NotificationType.Shift,
    notificationTypeDisplay: 'Shift',
    title: 'Upcoming Shift Reminder',
    body: 'You are scheduled to work on Monday at the Salt Lake City facility from 8:00 AM to 4:00 PM.',
    isRead: true,
    actionRequired: false,
    createdAt: '2025-01-09T18:30:00Z',
    readAt: '2025-01-09T19:05:00Z',
    senderName: 'Scheduling System',
    actions: [],
  },
  {
    id: 'c4d2e6a1-5e91-4a6b-9f3a-2b7d8e4c3c03',
    recipientId: 'b2e7c1a4-4d91-4f3a-a7c3-91f1d2a8c101',
    notificationType: NotificationType.Facility,
    notificationTypeDisplay: 'Facility',
    title: 'Parking Lot Maintenance',
    body: 'The employee parking lot in Provo will undergo maintenance this Friday. Limited parking will be available.',
    isRead: false,
    actionRequired: false,
    createdAt: '2025-01-08T14:00:00Z',
    senderName: 'Facilities Management',
    actions: [],
  },
  {
    id: '9e1a4b7d-3f52-4b8a-a6c1-0d2e9c8f4d04',
    recipientId: 'b2e7c1a4-4d91-4f3a-a7c3-91f1d2a8c101',
    notificationType: NotificationType.Payment,
    notificationTypeDisplay: 'Payment',
    title: 'Payroll Processed',
    body: 'Your bi-weekly payroll has been processed and will be deposited to your bank account within 1–2 business days.',
    isRead: false,
    actionRequired: true,
    createdAt: '2025-01-07T12:45:00Z',
    senderName: 'Payroll',
    actions: [
      {
        id: 2,
        actionType: 'link',
        actionLabel: 'View Pay Stub',
        actionUrl: 'https://company.example.com/payroll/paystub',
        isPrimary: true,
      },
    ],
  },
];
